import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'schedule/appointment-guard';

export const CALENDAR_APPOINTMENT_GUARD = {
  START: `${actionsScope}/START`,
  FINISH: `${actionsScope}/FINISH`,
  CLEAR: `${actionsScope}/CLEAR`,
};

export const calendarAppointmentGuardActions = {
  start: createAction(CALENDAR_APPOINTMENT_GUARD.START),
  finish: createAction(CALENDAR_APPOINTMENT_GUARD.FINISH),
  clear: createAction(CALENDAR_APPOINTMENT_GUARD.CLEAR),
};

const initialState = {
  pending: true,
  canCreate: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CALENDAR_APPOINTMENT_GUARD.START: {
      return {
        ...state,
        pending: true,
        canCreate: false,
      };
    }

    case CALENDAR_APPOINTMENT_GUARD.FINISH: {
      return {
        ...state,
        pending: false,
        canCreate: payload,
      };
    }

    case CALENDAR_APPOINTMENT_GUARD.CLEAR: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/schedule/appointmentGuard.js